/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  CreatePropertyNoteRequest,
  GetApiPropertyNotesList200,
  GetApiPropertyNotesListParams,
  NotFoundErrorResponse,
  PropertyNoteApiResource,
  UnauthorizedErrorResponse,
  UpdatePropertyNoteRequest
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiPropertyNotesListResponse200 = {
  data: GetApiPropertyNotesList200
  status: 200
}

export type getApiPropertyNotesListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiPropertyNotesListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiPropertyNotesListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiPropertyNotesListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiPropertyNotesListResponseSuccess = (getApiPropertyNotesListResponse200) & {
  headers: Headers;
};
export type getApiPropertyNotesListResponseError = (getApiPropertyNotesListResponse400 | getApiPropertyNotesListResponse401 | getApiPropertyNotesListResponse403 | getApiPropertyNotesListResponse404) & {
  headers: Headers;
};

export type getApiPropertyNotesListResponse = (getApiPropertyNotesListResponseSuccess | getApiPropertyNotesListResponseError)

export const getGetApiPropertyNotesListUrl = (propertyId: string,
    params?: GetApiPropertyNotesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/notes?${stringifiedParams}` : `/api/properties/${propertyId}/notes`
}

export const getApiPropertyNotesList = async (propertyId: string,
    params?: GetApiPropertyNotesListParams, options?: RequestInit): Promise<getApiPropertyNotesListResponse> => {
  
  return customFetch<getApiPropertyNotesListResponse>(getGetApiPropertyNotesListUrl(propertyId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type postApiPropertyNoteCreateResponse201 = {
  data: PropertyNoteApiResource
  status: 201
}

export type postApiPropertyNoteCreateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiPropertyNoteCreateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiPropertyNoteCreateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiPropertyNoteCreateResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type postApiPropertyNoteCreateResponseSuccess = (postApiPropertyNoteCreateResponse201) & {
  headers: Headers;
};
export type postApiPropertyNoteCreateResponseError = (postApiPropertyNoteCreateResponse400 | postApiPropertyNoteCreateResponse401 | postApiPropertyNoteCreateResponse403 | postApiPropertyNoteCreateResponse404) & {
  headers: Headers;
};

export type postApiPropertyNoteCreateResponse = (postApiPropertyNoteCreateResponseSuccess | postApiPropertyNoteCreateResponseError)

export const getPostApiPropertyNoteCreateUrl = (propertyId: string,) => {


  

  return `/api/properties/${propertyId}/notes`
}

export const postApiPropertyNoteCreate = async (propertyId: string,
    createPropertyNoteRequest: CreatePropertyNoteRequest, options?: RequestInit): Promise<postApiPropertyNoteCreateResponse> => {
  
  return customFetch<postApiPropertyNoteCreateResponse>(getPostApiPropertyNoteCreateUrl(propertyId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createPropertyNoteRequest,)
  }
);}


export type getApiPropertyNoteGetResponse200 = {
  data: PropertyNoteApiResource
  status: 200
}

export type getApiPropertyNoteGetResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiPropertyNoteGetResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiPropertyNoteGetResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiPropertyNoteGetResponseSuccess = (getApiPropertyNoteGetResponse200) & {
  headers: Headers;
};
export type getApiPropertyNoteGetResponseError = (getApiPropertyNoteGetResponse401 | getApiPropertyNoteGetResponse403 | getApiPropertyNoteGetResponse404) & {
  headers: Headers;
};

export type getApiPropertyNoteGetResponse = (getApiPropertyNoteGetResponseSuccess | getApiPropertyNoteGetResponseError)

export const getGetApiPropertyNoteGetUrl = (propertyId: string,
    id: string,) => {


  

  return `/api/properties/${propertyId}/notes/${id}`
}

export const getApiPropertyNoteGet = async (propertyId: string,
    id: string, options?: RequestInit): Promise<getApiPropertyNoteGetResponse> => {
  
  return customFetch<getApiPropertyNoteGetResponse>(getGetApiPropertyNoteGetUrl(propertyId,id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type putApiPropertyNoteUpdateResponse200 = {
  data: PropertyNoteApiResource
  status: 200
}

export type putApiPropertyNoteUpdateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type putApiPropertyNoteUpdateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiPropertyNoteUpdateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type putApiPropertyNoteUpdateResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type putApiPropertyNoteUpdateResponseSuccess = (putApiPropertyNoteUpdateResponse200) & {
  headers: Headers;
};
export type putApiPropertyNoteUpdateResponseError = (putApiPropertyNoteUpdateResponse400 | putApiPropertyNoteUpdateResponse401 | putApiPropertyNoteUpdateResponse403 | putApiPropertyNoteUpdateResponse404) & {
  headers: Headers;
};

export type putApiPropertyNoteUpdateResponse = (putApiPropertyNoteUpdateResponseSuccess | putApiPropertyNoteUpdateResponseError)

export const getPutApiPropertyNoteUpdateUrl = (propertyId: string,
    id: string,) => {


  

  return `/api/properties/${propertyId}/notes/${id}`
}

export const putApiPropertyNoteUpdate = async (propertyId: string,
    id: string,
    updatePropertyNoteRequest: UpdatePropertyNoteRequest, options?: RequestInit): Promise<putApiPropertyNoteUpdateResponse> => {
  
  return customFetch<putApiPropertyNoteUpdateResponse>(getPutApiPropertyNoteUpdateUrl(propertyId,id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updatePropertyNoteRequest,)
  }
);}


export type deleteApiPropertyNoteDeleteResponse204 = {
  data: void
  status: 204
}

export type deleteApiPropertyNoteDeleteResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type deleteApiPropertyNoteDeleteResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type deleteApiPropertyNoteDeleteResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type deleteApiPropertyNoteDeleteResponseSuccess = (deleteApiPropertyNoteDeleteResponse204) & {
  headers: Headers;
};
export type deleteApiPropertyNoteDeleteResponseError = (deleteApiPropertyNoteDeleteResponse401 | deleteApiPropertyNoteDeleteResponse403 | deleteApiPropertyNoteDeleteResponse404) & {
  headers: Headers;
};

export type deleteApiPropertyNoteDeleteResponse = (deleteApiPropertyNoteDeleteResponseSuccess | deleteApiPropertyNoteDeleteResponseError)

export const getDeleteApiPropertyNoteDeleteUrl = (propertyId: number,
    id: number,) => {


  

  return `/api/properties/${propertyId}/notes/${id}`
}

export const deleteApiPropertyNoteDelete = async (propertyId: number,
    id: number, options?: RequestInit): Promise<deleteApiPropertyNoteDeleteResponse> => {
  
  return customFetch<deleteApiPropertyNoteDeleteResponse>(getDeleteApiPropertyNoteDeleteUrl(propertyId,id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


